import { createEventBus } from "../../Common/eventBusFactory";

export const eventBus = createEventBus();

export const OPEN_AUTO_SEED_MODAL = "onOpenAutoSeedModal";
export const OPEN_MEDAL_PLACES_MODAL = "onOpenMedalPlacesModal";
export const OPEN_BRACKET_DEFAULTS_MODAL = "onOpenBracketDefaultsModal";
export const OPEN_SHARE_BRACKETS_MODAL = "onOpenShareBracketsModal";
